import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { rootApi } from '../services/baseApi';
import { planApi } from '../services/planApi';
import { siteApi } from '../services/siteApi';
import { sensorApi } from '../services/sensorApi';
import { alarmApi } from '../services/alarmApi';
import { dataApi } from '../services/dataApi';
import authReducer from './slices/authSlice';
import themeReducer from './slices/themeSlice';
import loadingReducer from './slices/loadingSlice';

export const store = configureStore({
  reducer: {
    [rootApi.reducerPath]: rootApi.reducer,
    [planApi.reducerPath]: planApi.reducer,
    [siteApi.reducerPath]: siteApi.reducer,
    [sensorApi.reducerPath]: sensorApi.reducer,
    [alarmApi.reducerPath]: alarmApi.reducer,
    [dataApi.reducerPath]: dataApi.reducer,
    auth: authReducer,
    theme: themeReducer,
    loading: loadingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      rootApi.middleware,
      planApi.middleware,
      siteApi.middleware,
      sensorApi.middleware,
      alarmApi.middleware,
      dataApi.middleware
    ),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;